import {useMemo} from 'react';

import {FormSection} from '../../../../../../components/FormMaker/types';
import {useApiRead} from '../../../../../../hooks/useApiRead';
import {GetRoutes} from '../../../../../../lib/api/GET/GetRoutes';
import {ProfessionalArea} from '../../../../../../types/ProfessionalArea';
import {ApplicantProfile} from '../../../types';

export const useExperienceSection = (profile: ApplicantProfile): FormSection[] => {
  const {data: professionalAreas} = useApiRead<ProfessionalArea[]>({path: GetRoutes.professionalAreas});

  return useMemo<FormSection[]>(
    () => [
      {
        type: 'track-record',
        data: {
          options: (professionalAreas || []).map((entry) => {
            return {
              id: `${entry.id}`,
              name: entry.name,
              methodDepartmentCategoryId: `${entry.methodDepartmentCategoryId}`,
              metadata: {
                yearsOfExperience: '',
                label: entry.label,
              },
            };
          }),
          name: 'professionalExperience',
          initialValue: profile.professionalExperience,
        },
      },
    ],
    [profile.professionalExperience, professionalAreas]
  );
};
